export default __webpack_public_path__ + "static/char-13-45a6795ad4208a3dfcf847bc0f6455d8.webp";